exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.md-headline[data-v-503d2f65]{width:100%\n}\n.uploader[data-v-503d2f65]{width:56px;height:56px;position:relative\n}\n.uploader .md-fab[data-v-503d2f65]{margin:0\n}\n.uploader .md-spinner[data-v-503d2f65]{position:absolute;top:50%;left:50%;transform:translate(-50%, -50%)\n}\n.cancel-button[data-v-503d2f65]{background:rgba(255,0,0,.5882352941);color:rgba(255,255,255,.8705882353) !important;font-weight:900;border-radius:29px;font-size:12px\n}\n.md-invalid[data-v-503d2f65]{color:#ff5722;display:block;left:0px;height:20px;position:absolute;bottom:-22px;font-size:12px\n}\n.centered[data-v-503d2f65]{position:absolute;margin-top:55px\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-503d2f65","scoped":true,"sourceMap":true}!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/shared-components/upload/VideoUploader.vue
// module id = 202
// module chunks = 0